// extracted by mini-css-extract-plugin
export default {"app":"App_app__ozyN1","header":"App_header__G9FVm","logo":"App_logo__8q6ZT","info":"App_info__vaSms","markdown":"App_markdown__CcRHL"};